export enum InputType {
  LongText,
  ShortText,
  Numeric,
  Email,
  Textarea,
}
